import React from 'react';
import ConnectedCustomersWidget
  from '../../connected-customers/ConnectedCustomersWidget';

function ConnectedCustomers(props) {
  return (
      <ConnectedCustomersWidget />
  );
}

export default ConnectedCustomers;
